import React from "react";
import { useNavigate } from "react-router-dom";
import "./Styles/AccountSuccess.css";

export default function AccountSuccess() {
  const navigate = useNavigate();

  const handleContinue = () => {
    localStorage.setItem("fromSignup", "true");
    navigate("/job-auth");
  };

  return (
    <div className="job-success-container">
      <div className="job-success-content">
        <img
          src="https://res.cloudinary.com/diomlp95m/image/upload/v1752735823/Youthplus_Logoo_pjfjku.jpg"
          alt="YouthPlus"
          className="job-success-logo"
        />

        <img
          src="https://res.cloudinary.com/diomlp95m/image/upload/v1752735291/thimbs_amv0do.png"
          alt="Thumbs Up"
          className="job-success-icon"
        />

        <h1 className="job-success-heading">Account Successfully Created</h1>

        <button onClick={handleContinue} className="job-success-button">
          Continue
        </button>
      </div>
    </div>
  );
}
